import { CollectionTypeDto } from "../dto/CollectionType.Dto";
import { CollectionType } from "../../entity/CollectionType";
import { toDate } from "../../utils/GlobalFunctions";

export const collectionActionTypeMapper = (
  dto: CollectionTypeDto[],
): CollectionType[] => {
  return dto.map((item) => {
    return {
      id: item.id,
      collectionId: item.collectionId,
      actionId: item.actionId,
      companyId: item.companyId,
      createdAt: toDate(item.createdAt),
      updatedAt: toDate(item.updatedAt),
    };
  });
};
